// src/Utils/walletCalculations.js

import categoryRates from "../Data/categoryRates";

/**
 * يحسب المبلغ الواجب دفعه بناءً على المبلغ والفئة
 */
export function calculateFinalAmount(amount, category) {
  if (!amount || !categoryRates[category]) return "";
  return (parseFloat(amount) * categoryRates[category]).toFixed(2);
}

/**
 * يحسب المبلغ الأصلي عند إدخال المبلغ الواجب دفعه
 */
export function calculateBaseAmount(finalAmount, category) {
  if (!finalAmount || !categoryRates[category]) return "";
  return (parseFloat(finalAmount) / categoryRates[category]).toFixed(2);
}
